const ManageableTypesEnum = {
  CUSTOM_FIELD: "Custom Field",
  LOCATION: "Location",
  QUEUE: "Queue",
  TEAM_MEMBERS: "Team Members",
  SUBSCRIPTION: "Subscription",
}

export default ManageableTypesEnum
